import { defineEvent, type EventPayload } from '@nexus/core';
import { z } from 'zod';

// Events carry IDs, never personal data: subscribers load what they need through the public API.

export const appointmentCreated = defineEvent(
  'appointments.appointment.created',
  z.object({ appointmentId: z.uuid() }),
);
export type AppointmentCreated = EventPayload<typeof appointmentCreated>;

/** Time, place, people or other fields changed, or the appointment was cancelled or restored. */
export const appointmentUpdated = defineEvent(
  'appointments.appointment.updated',
  z.object({ appointmentId: z.uuid() }),
);
export type AppointmentUpdated = EventPayload<typeof appointmentUpdated>;

export const appointmentDeleted = defineEvent(
  'appointments.appointment.deleted',
  z.object({ appointmentId: z.uuid() }),
);
export type AppointmentDeleted = EventPayload<typeof appointmentDeleted>;
